import { useLang } from '@/app/utils/useLang';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import Icon from './Icon';

interface ActivityRulesProps {}

const rules: React.ReactNode[] = [
    'Each device may only participate once; duplicate submissions will be deemed invalid.',
    'Mystery box gifts are issued only after the returned device passes inspection. Users will be notified by email if the review is not approved.',
    'In cases of fraud or abuse, EcoFlow reserves the right to withhold or revoke rewards. This includes but is not limited to:',
    ' a. The item received by EcoFlow does not match your description.',
    ' b. Submitting duplicate applications for the mystery box gift.',
    <>
        Vouchers can only be applied to designated products on{' '}
        <a href="https://us.ecoflow.com" target="_blank" rel="noopener noreferrer" className="rule-link">
            us.ecoflow.com
        </a>
        .
    </>,
    'If an order using a voucher is cancelled, the voucher will also be cancelled and its value will not be refunded in cash.',
    'We will send the mystery box gift to your provided email address within 3 business days of receiving the returned device.',
    'We will review your trade-in application within 2 business days and send your mystery box gift upon approval.',
    'Vouchers apply to new purchases only and cannot be used to offset price differences on completed orders.',
    'Three-month return deadline applies. Late returns will result in disqualification and forfeiture of the mystery box gift.',
];

const ActivityRules: React.FC<ActivityRulesProps> = (props) => {
    const { t } = useLang('ActivityRules');
    const { locale = 'us' } = useRouter();

    return (
        <div className={`${styles.ActivityRules} GtmModuleData-section sr-layout-sub`} data-section-id="service-renewal-activity-rules" id="activity-rules">
            <div className="">
                <h2 className="sr-layout-sub-title">
                    <span className="title-dot">
                        <Icon />
                    </span>
                    {t('title')}
                </h2>
                <ul className="rules-list">
                    {(() => {
                        let counter = 0;
                        return rules.map((rule, index) => {
                            const isSubItem = typeof rule === 'string' && /^\s*[a-z]\./.test(rule);
                            if (!isSubItem) counter++;
                            return (
                                <li key={index} className={`rule-item${isSubItem ? ' rule-sub-item' : ''}`}>
                                    <span className="rule-text">
                                        {isSubItem ? (
                                            rule
                                        ) : (
                                            <>
                                                {counter}. {rule}
                                            </>
                                        )}
                                    </span>
                                </li>
                            );
                        });
                    })()}
                </ul>
            </div>
        </div>
    );
};

export default ActivityRules;
